export const TEST_ID = {
  container: 'spinner-container',
};
